import React from 'react'

export function getBrowserVisibilityProp() {
  if (typeof document.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    return 'visibilitychange'
  }

  if (typeof document.msHidden !== 'undefined') {
    return 'msvisibilitychange'
  }

  // if (typeof document.webkitHidden !== 'undefined') {
  return 'webkitvisibilitychange'
  // }
}

export function getBrowserDocumentHiddenProp() {
  if (typeof document.hidden !== 'undefined') {
    return 'hidden'
  }

  if (typeof document.msHidden !== 'undefined') {
    return 'msHidden'
  }

  // if (typeof document.webkitHidden !== 'undefined') {
  return 'webkitHidden'
  // }
}

export function getIsDocumentHidden() {
  return !document[getBrowserDocumentHiddenProp()]
}

export function usePageVisibility() {
  const [isVisible, setIsVisible] = React.useState(getIsDocumentHidden())
  const onVisibilityChange = () => setIsVisible(getIsDocumentHidden())

  React.useEffect(() => {
    const visibilityChange = getBrowserVisibilityProp()

    document.addEventListener(visibilityChange, onVisibilityChange, false)

    return () => {
      document.removeEventListener(visibilityChange, onVisibilityChange)
    }
  })

  return isVisible
}
